// handle function for the active item when in IO
let pageIsScrolling = false
let activeNavLink = false
const activeNavClass = ['active']

export const initMobileScrollSpy = ($el, spyTargetClass) => {
  initMicroNavScrollListener($el, spyTargetClass)
  setFlagOnVerticalScroll()
  initScrollOnClick()
}

const handleMicroNavScrollListenerStep = (entries) => {
  entries.forEach(({target: {id}, isIntersecting}) => {
    // find the related html micro nav link where href matches id on the desktop nav
    const relatedNavLink = document.getElementById('js-micro-nav-mobile').querySelector(`[href="#${id}"]`)

    if (isIntersecting && relatedNavLink && relatedNavLink != activeNavLink) {
      // set related nav link to active classes
      relatedNavLink.classList.add(activeNavClass)

      if (activeNavLink) {
        activeNavLink.classList.remove(activeNavClass)
      }

      activeNavLink = relatedNavLink
      const waitForEndOfScrolling = setInterval(() => {
        if (!pageIsScrolling) {
          scrollCenter('.fsa__horizontal-listbox', '.active', 300)
          clearInterval(waitForEndOfScrolling)
        }
      }, 250)
    }
  })
}

const initMicroNavScrollListener = ($el, spyTargetClass) => {
  const sections = [...$el.querySelectorAll(`.${spyTargetClass}`)]

  const ioOptions = {
    threshold: 0, // detect when visibility passes this percent
    rootMargin: "-30% 0px -60%",
  }

  const io = new IntersectionObserver(handleMicroNavScrollListenerStep, ioOptions)

  io.POLL_INTERVAL = 100 // Time in milliseconds

  sections.forEach((section) => {
    io.observe(section)
  })
}

const initScrollOnClick = () => {
  [...document.querySelectorAll('.fsa__horizontal-listbox a')].forEach((item) => {
    item.addEventListener('click', function (event) {
      event.preventDefault()
      window.scroll(0, document.querySelector(item.dataset.target).offsetTop - 55)
    })
  })
}

const getWidth = element => {
  return parseFloat(window.getComputedStyle(element).width) - parseFloat(window.getComputedStyle(element).paddingLeft) - parseFloat(window.getComputedStyle(element).paddingRight)
}

const scrollCenter = (elementToObserve, elementToScroll, speed) => {
  let parent = document.querySelector(elementToObserve)
  let active = parent.querySelector(elementToScroll)
  if (!active) {
    return false
  }
  let activeWidth = getWidth(active) / 2

  let pos = active.offsetLeft + activeWidth
  let elW = getWidth(parent) / 2
  pos = pos - elW

  parent.scroll({
    left: pos,
    behavior: 'smooth'
  })
}
const setFlagOnVerticalScroll = () => {
  window.onscroll = () => pageIsScrolling = true
  setInterval(() => {
    if (pageIsScrolling) {
      pageIsScrolling = false
    }
  }, 250)
}